import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, TextField } from "@mui/material";
import { red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import { ENHANCEDLEGALFINANCIALCOMPONENTENUM } from "../Content";
import { AllProductsEnum } from "../../QuoteRequest/Content";
export const ServiceDistributionTable = ({ headers, rows, isEditable, handleChange, error, requestedCurrency, productId }) => {
    const revenueStage2ReqCurrency = rows[0] ? Number(rows[0]?.revenueStage2ReqCurrency.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : '';
    const revenueStage3ReqCurrency = rows[0] ? Number(rows[0]?.revenueStage3ReqCurrency.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : '';
    const revenueStage4ReqCurrency = rows[0] ? Number(rows[0]?.revenueStage4ReqCurrency.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : '';
    const revenueStage5ReqCurrency = rows[0] ? Number(rows[0]?.revenueStage5ReqCurrency.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : '';
    const totalUtilizationPercent = `${Math.round(rows?.reduce((sum, obj) => sum + (obj["utilizationPercent"] || 0), 0))?.toFixed(2)} %`
    const GetValue = function getUtilValue(countryId, componentId, id) {

        const filterIndex = error?.findIndex(item => item.countryId == countryId && item.componentId === componentId && item.errorField === id);

        if (filterIndex !== -1) {
            return error[filterIndex].errorMessage;
        }
    }
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: "400" }} aria-label="customized table">
                <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell key={index}>{header.label} {header.id === "extAffCostTotalReqCurrency" || header.id ==="totalCostReqCurrency" || header.id ==="revenueStage1ReqCurrency" ? "(" + requestedCurrency +")" : null }</TableCell>

                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows?.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {headers.map((header) => (

                                <TableCell>
                                    {isEditable && header.id === "utilizationPercent"
                                        && (productId !== AllProductsEnum.ENHANCEDLEGALSERVICES
                                            && productId !== AllProductsEnum.ENHANCEDFINANCIALSERVICES) ?
                                        <>
                                            <TextField
                                                size="small"
                                                defaultValue={row[header.id]}
                                                onChange={(e) => handleChange(row.componentId, row.countryId, header.id, e.target.value)}
                                            />
                                             {GetValue(row.countryId, row.componentId, header.id)?
                                                < Typography variant="caption" sx={{ color: red[500],fontSize:'10px',whiteSpace:'nowrap' }} display="block" gutterBottom>
                                                  {GetValue(row.countryId, row.componentId, header.id)}
                                            </Typography>:
                                     
                                                <div className="divheight"></div>}

                                        </> : row[header?.id] && header?.id === "utilizationPercent"

                                            ? row[header?.id] + '%'

                                            : (isNaN(row[header?.id]) || header?.id === "componentName")

                                                ? row[header?.id]

                                                : Number(

                                                    (row[header?.id] && !isNaN(row[header?.id]))

                                                    ? row[header?.id]?.toFixed(2)

                                                        : 0).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 })
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                    <TableRow className="totalRow">
                        <TableCell>Total</TableCell>
                        <TableCell colSpan={6}>{totalUtilizationPercent}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Box className="utilizationStatus">
                <Box className="d-flex">
                    <div className="customerDetails">
                        <div className="formdata">
                            <label>Total Revenue Stage 2 ({requestedCurrency})</label>

                            <TextField
                                className="formInputTwo"
                                name="annualUtilizationThreeYrs"
                                disabled
                                value={revenueStage2ReqCurrency}
                                aria-readonly
                            />
                        </div>
                    </div>
                    <div className="customerDetails">
                        <div className="formdata">
                            <label>Total Revenue Stage 3 ({requestedCurrency})</label>

                            <TextField
                                className="formInputTwo"
                                name="annualUtilizationThreeYrs"
                                disabled
                                value={revenueStage3ReqCurrency}
                                aria-readonly
                            />
                        </div>
                    </div>
                    <div className="customerDetails">
                        <div className="formdata">
                            <label>Total Revenue Stage 4 ({requestedCurrency})</label>

                            <TextField
                                className="formInputTwo"
                                name="annualUtilizationThreeYrs"
                                disabled
                                value={revenueStage4ReqCurrency}
                                aria-readonly
                            />
                        </div>
                    </div>
                    <div className="customerDetails">
                        <div className="formdata">
                            <label>Total Revenue Stage 5 ({requestedCurrency})</label>

                            <TextField
                                className="formInputTwo"
                                name="annualUtilizationThreeYrs"
                                disabled
                                value={revenueStage5ReqCurrency}
                                aria-readonly
                            />
                        </div>
                    </div>
                </Box>
            </Box>
        </TableContainer>
    );
};

export default ServiceDistributionTable;
